import React from 'react';
import styled from "styled-components";

const labelText = ["Usuario", "Espacio", "Personalizar", "Confirmar email"]
const Nav = (props) => {
  const dots = [];
  for (let i = 1; i <= props.totalSteps; i += 1) {
    dots.push((
      <WizardStep 
        key={`step-${i}`} 
        onClick={() => { if (i < props.currentStep) { props.goToStep(i) } }}
        isClickable={i < props.currentStep}
        isActive={i === props.currentStep}
      >
        {(i < props.currentStep) && <StepIcon className="fa-solid fa-check" />}
        {(i === props.currentStep) && <StepIcon className="fa-solid fa-circle-dot" />}
        {(i > props.currentStep) && <StepIcon className="fa-regular fa-circle" />}
        <StepLabel>{labelText[i - 1]}</StepLabel>
      </WizardStep>
    ));
  }
  return (
    <Wrapper>
      <Line>{dots}</Line>
    </Wrapper>
  );
};

export default Nav;

const Wrapper = styled.div`
  text-align: center;
  margin: 2em 0;
  position: relative;
  width: 100%;
  
  :before {
    content: '';
    position: absolute;
    top: 1.5em;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(to right, var(--wc-main-secondary), var(--wc-main-primary));
    z-index: 1;
  }
  
  @media (max-width: 768px) {
    margin: 1em 0;
  }
`

const Line = styled.div`
  padding: 0 2em;
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 2;
  
  @media (max-width: 768px) {
    padding: 0 1em;
  }
`

const WizardStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  cursor: ${props => props.isClickable ? 'pointer' : 'default'};
  transition: all 0.3s ease;
  
  &:hover {
    transform: ${props => props.isClickable ? 'translateY(-2px)' : 'none'};
  }
`

const StepIcon = styled.i`
  background: white;
  color: ${props => {
    if (props.className?.includes('fa-check')) return 'var(--wc-main-secondary)';
    if (props.className?.includes('fa-circle-dot')) return 'var(--wc-main-primary)';
    return '#ccc';
  }};
  font-size: 1.5em;
  padding: 0.5em;
  border-radius: 50%;
  border: 2px solid ${props => {
    if (props.className?.includes('fa-check')) return 'var(--wc-main-secondary)';
    if (props.className?.includes('fa-circle-dot')) return 'var(--wc-main-primary)';
    return '#ccc';
  }};
  transition: all 0.3s ease;
  
  @media (max-width: 768px) {
    font-size: 1.2em;
    padding: 0.4em;
  }
`

const StepLabel = styled.span`
  display: block;
  font-size: 0.8em;
  font-weight: 600;
  margin-top: 0.5em;
  color: ${props => {
    if (props.className?.includes('fa-check')) return 'var(--wc-main-secondary)';
    if (props.className?.includes('fa-circle-dot')) return 'var(--wc-main-primary)';
    return '#666';
  }};
  
  @media (max-width: 768px) {
    font-size: 0.7em;
  }
  
  @media (max-width: 480px) {
    font-size: 0.6em;
  }
`
